// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'browser-code';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M15.938.563H2.062a1.5 1.5 0 0 0-1.5 1.5v13.874a1.5 1.5 0 0 0 1.5 1.5h13.876a1.5 1.5 0 0 0 1.5-1.5V2.063a1.5 1.5 0 0 0-1.5-1.5zM.578 4.174h16.85' />
    <path d='M4.676 13.92a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75M9 13.92a.375.375 0 0 1 0-.75m0 .75a.375.375 0 0 0 0-.75m4.324.75a.375.375 0 0 1 0-.75m0 .75a.375.375 0 1 0 0-.75M4.676 7.357l-1.5 1.5 1.5 1.5m8.648-3 1.5 1.5-1.5 1.5' />
  </g>
);

export const viewBox = '0 0 18 18';
